<template>
  <div class="vertical-align-top" v-for="program in data.programs">
    <div class="wrapper">
      <h5 class="title">{{ program.title }}</h5>
      <p class="sub-title">
        {{ program.contributorName }}
      </p>

      <p class="desc" v-if="program.description">{{ program.description }}</p>
      <p v-if="program.phoneNumber">
        P:
        {{ program.phoneNumber }}
      </p>
      <a
        v-if="program.contributorWebsiteUrl"
        :href="program.contributorWebsiteUrl"
        target="_blank"
        >Website</a
      >
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['data'])
console.log(props.data)
props.data.programs.sort((a, b) => {
  if (a.title < b.title) return -1
  if (a.title > b.title) return 1
  return 0
})
</script>
